import { SVGProps, Ref, forwardRef } from 'react';

export const PhoneWaveFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M9.2 10.45c-.449-.27-1.162-.772-2.013-1.621-.854-.854-1.355-1.57-1.625-2.02-.19-.314-.187-.695-.043-1.032l.868-2.03L3.78 0c-6.136 1.732-3.936 7.351.475 11.76 4.41 4.41 10.009 6.585 11.745.455L12.252 9.61l-2.007.878c-.34.149-.726.153-1.045-.038"
                    fill="currentColor"
                />
                <path
                    d="M15.76 6.065A8.01 8.01 0 0 0 9.933.234l-.247 1.383a6.61 6.61 0 0 1 4.693 4.693z"
                    fill="currentColor"
                />
                <path
                    d="M13.199 6.522a5.01 5.01 0 0 0-3.725-3.724l-.246 1.38a3.6 3.6 0 0 1 2.59 2.59z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
PhoneWaveFilledSize16Glyph.displayName = 'PhoneWaveFilledSize16Glyph';
